import React from "react";
import uuid from "uuid/v1";

const CaptionElement = (props) => {
  const { captionHeaders } = props;

  const transformHeaderName = (name) => {
    if (name && name.includes("::")) {
      return name.split("::")[0];
    }
    return name || "";
  };
  const renderRowElements = (header) => {
    const arr = Array.isArray(header) ? header : [header];
    return arr.map((e) => {
      return (
        <div
          className="caption-element"
          key={uuid()}
          style={{ flexGrow: e.colspan ? e.colspan : 1 }}
        >
          {transformHeaderName(e.value)}
        </div>
      );
    });
  };

  const renderCaption = () => {
    return captionHeaders.map((h, i) => {
      return (
        <div style={{ display: "flex", flexWrap: "nowrap" }} key={i}>
          {renderRowElements(h)}
        </div>
      );
    });
  };
  return <div style={{ marginTop: "1rem" }}>{renderCaption()}</div>;
};

export default CaptionElement;
